var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharliLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 109,
    viewBox: "0 0 196 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_1033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1988 107.263C48.1197 107.263 40.6751 105.974 33.8649 103.397C27.2671 100.952 21.2152 97.2325 16.0547 92.4497C10.9828 87.7132 6.95482 81.9707 4.22803 75.5893C1.40934 69.0699 0 61.9172 0 54.1313C0 46.3454 1.41058 39.1927 4.23173 32.6733C6.95896 26.2932 10.987 20.552 16.0584 15.8166C21.219 11.0357 27.2693 7.31614 33.8649 4.86954C40.6776 2.28985 48.1222 1 56.1988 1C65.6355 1 74.0768 2.62986 81.5227 5.88959C88.8325 9.04808 95.2323 13.9915 100.135 20.2664L81.7407 36.8976C78.4342 33.0047 74.7852 30.0369 70.7937 27.9944C66.7232 25.9351 62.2165 24.8867 57.655 24.9379C53.7176 24.895 49.8068 25.5882 46.124 26.9817C42.7347 28.2717 39.6701 30.2903 37.1468 32.895C34.6068 35.5677 32.6232 38.7184 31.3111 42.1642C29.8608 45.985 29.1436 50.0449 29.1971 54.1313C29.1443 58.2192 29.8628 62.2804 31.3148 66.1021C32.6269 69.5478 34.6105 72.6986 37.1505 75.3712C39.6725 77.9775 42.7374 79.9965 46.1277 81.2846C49.8091 82.6781 53.7189 83.37 57.655 83.3247C62.2159 83.3732 66.7213 82.3222 70.79 80.2608C74.779 78.2183 78.428 75.2012 81.737 71.2097L100.131 87.841C95.2196 94.1249 88.8241 99.0905 81.519 102.292C74.078 105.603 65.638 107.26 56.1988 107.263Z",
    fill: "url(#paint0_linear_6_1033)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.857 45.3907V34.536C175.858 34.3305 175.801 34.1289 175.691 33.9548C175.582 33.7807 175.426 33.6413 175.24 33.553L112.525 3.75715C112.361 3.67996 112.18 3.6458 111.999 3.6579C111.818 3.66999 111.644 3.72794 111.491 3.82629C111.339 3.92463 111.214 4.06013 111.129 4.22003C111.043 4.37992 111 4.55895 111.003 4.74024V21.7632C111.005 21.9681 111.063 22.1685 111.172 22.342C111.281 22.5156 111.436 22.6555 111.62 22.7463L147.503 39.8063L111.613 57.1767C111.429 57.2659 111.274 57.4052 111.166 57.5784C111.058 57.7517 111.002 57.952 111.003 58.1561V75.1828C111.001 75.3637 111.045 75.5422 111.131 75.7015C111.216 75.8609 111.341 75.9959 111.493 76.094C111.645 76.1922 111.819 76.2502 112 76.2628C112.18 76.2754 112.361 76.242 112.525 76.1659L175.24 46.3701C175.425 46.282 175.581 46.1432 175.69 45.9698C175.8 45.7964 175.858 45.5956 175.857 45.3907Z",
    stroke: "url(#paint1_linear_6_1033)",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.639 88.8684C177.456 87.2291 179.817 86.3218 182.264 86.3218C184.711 86.3218 187.072 87.2291 188.889 88.8684C190.665 90.5636 191.555 92.7897 191.557 95.5468C191.56 98.3039 190.716 100.53 189.025 102.225C187.34 103.923 185.178 104.772 182.539 104.772C179.78 104.772 177.496 103.923 175.687 102.225C173.879 100.528 172.973 98.3014 172.971 95.5468C172.971 92.7897 173.86 90.5636 175.639 88.8684Z",
    stroke: "url(#paint2_linear_6_1033)",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.892 90.5906V100.503C164.864 101.593 164.405 102.628 163.616 103.382C162.827 104.135 161.773 104.546 160.682 104.524H115.223C112.888 104.524 110.992 102.724 110.992 100.503V90.5906C110.992 88.3731 112.888 86.5696 115.223 86.5696H160.682C162.999 86.5696 164.892 88.3731 164.892 90.5906Z",
    stroke: "url(#paint3_linear_6_1033)",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_1033",
    x1: 117.029,
    y1: 115.061,
    x2: 27.9516,
    y2: 25.9875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_1033",
    x1: 108.364,
    y1: 39.9615,
    x2: 178.496,
    y2: 39.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_1033",
    x1: 170.528,
    y1: 95.5468,
    x2: 194,
    y2: 95.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_1033",
    x1: 108.364,
    y1: 95.5468,
    x2: 167.534,
    y2: 95.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81C34C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#009AD8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharliLogoSmall);
export default __webpack_public_path__ + "static/media/charli-logo-small.abcc94145cab1e77d6883c338dd3a352.svg";
export { ForwardRef as ReactComponent };